import { Card, Collapse } from 'antd';
import styled from 'styled-components';
import { TextRegular12, TextSemibold12 } from 'styles/typography';
import { IFieldListItemProps } from '../../slice/types';

export const DetailsCard = styled(Card)`
  margin-top: 12px;
  overflow: hidden;
  padding: 0;
  .ant-card-body {
    overflow: auto;
    height: calc(100% - 58px);
    padding: 0;
  }
`;

export const FieldsListCollapseItem = styled(Collapse.Panel)<
  IFieldListItemProps
>`
  background: #fff;
  .ant-collapse-header {
    background: ${p => (p.$isSelected ? '#1890FF' : 'transparent')};
  }
  .ant-collapse-content-box {
    background: #bae7ff;
    padding: 12px 12px 1px 12px !important;
  }
`;

export const FieldsListItemHeader = styled.div<IFieldListItemProps>`
  display: flex;
  flex-direction: column;
  align-items: normal;
`;

export const FieldId = styled(TextSemibold12)<IFieldListItemProps>`
  color: ${p => (p.$isSelected ? '#fff' : '#000')};
`;

export const FieldArea = styled(TextRegular12)<IFieldListItemProps>`
  color: ${p => (p.$isSelected ? '#fff' : '#8c8c8c')};
`;
